import React from 'react';
const Footer = () => {
    return (
      <div>
         <div class="footer-copyright text-center pt-25 pb-25 " style={{backgroundColor:'#f3f3f3',marginTop:'100px'}}>
                            <span style={{fontSize:'15px'}}>Copyright © 2024 | <b>Madhan Kumar Mamidala.</b> All Rights Reserved.</span>
                        </div>
      </div>
    );
  }
  
  export default Footer;